import React from "react";

export default ({ title, children }) => {
  return <>{children}</>;
};
